import { Link } from 'react-router-dom'

import { BsInstagram } from 'react-icons/bs'
import { BsLinkedin } from 'react-icons/bs'
import { BsYoutube } from 'react-icons/bs'

export default function Front() {
  return (
    <div className="font-inter relative bg-[#3a3864] tracking-tight text-gray-300 antialiased">
      <div className="container relative">
        <nav className="flex items-center justify-between pt-6">
          <a href="/">
            <svg
              className="h-6 w-6 fill-current md:hidden"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
            </svg>
          </a>
          <div className="flex items-center md:block">
            <Link
              className="btn2 mr-2 bg-indigo-500 font-semibold hover:text-white"
              to="/login"
            >
              Log In
            </Link>
            <Link
              className="btn2 rounded bg-indigo-600 hover:bg-indigo-500"
              to="/signup"
            >
              Sign up
            </Link>
          </div>
        </nav>
        <img
          alt="peacemind logo"
          className="mx-auto block h-[100px] w-[150px]"
          src="/img/logo2.png"
        />
        <h1 className="my-6 text-center font-front text-5xl uppercase leading-tight text-white xl:text-6xl">
          Peace of Mind
        </h1>

        <div className="mx-auto mb-6 flex max-w-xl flex-col gap-6 text-center text-xl">
          <p>
            Created by a team of three high schoolers from California, <br />
            <span className="">Peace of Mind</span> aims to alleviate the mental
            health issues on and above the Earth <br />
            through providing a space for journaling and self-expression.
          </p>
          <p>
            By the means of sentiment and word choice analysis, we are able to
            effectively diagnose of the mental health issue type and severity.
          </p>

          <p>
            As high schoolers under consistent stress and anxiety, we empathize
            with the pains the rest of the world and those in space, and wish to
            contribute to identifying mental health issues in space.
          </p>
          <p> Start today by jotting down how you feel right now.</p>
        </div>
        <div className="mx-auto mb-6 flex max-w-xs flex-col justify-center sm:max-w-full sm:flex-row">
          <Link
            className="whitespace-no-wrap btn2 btn2-tall mb-4 w-full bg-indigo-600 hover:bg-indigo-500 sm:mr-2 md:w-auto"
            to="/signup"
          >
            Get started
          </Link>
        </div>
        <div className="mb-16 flex justify-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/O4rV8pBrkD0?start=47"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        <div>
          <h2 className="title font-front sm:text-4xl md:text-5xl">
            "Together, we can redefine mental health in space"
          </h2>
          <p className="intro mx-auto mb-16 sm:max-w-xl">
            Meet the Co-Founders of Peace of Mind!
          </p>
          <ul className="mb-20 flex flex-col flex-wrap justify-center border-b-2 border-gray-800 text-center sm:flex-row">
            <li className="mb-8 w-full px-6 sm:mb-16 md:w-1/2 lg:w-1/3">
              <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-700 text-3xl text-white">
                <img src="img/feature-tile-icon-01.svg" alt="" />
              </span>
              <h3 className="mb-2 text-2xl font-bold text-white">Chloe Kim</h3>
              <p className="mx-auto max-w-xs text-lg">
                I do marketing, UI design, and community outreach with Marissa.
                I specialize in creating video materials.
              </p>
            </li>
            <li className="mb-8 w-full px-6 sm:mb-16 md:w-1/2 lg:w-1/3">
              <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-700 text-3xl text-white">
                <img src="img/feature-tile-icon-02.svg" alt="" />
              </span>
              <h3 className="mb-2 text-2xl font-bold text-white">Julia Kang</h3>
              <p className="mx-auto max-w-xs text-lg">
                I do the technical development which includes actually creating
                the product. I have been coding since 6th grade and have an
                interest in web development and machine learning.
              </p>
            </li>
            <li className="mb-8 w-full px-6 sm:mb-16 md:w-1/2 lg:w-1/3">
              <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-700 text-3xl text-white">
                <img src="img/feature-tile-icon-03.svg" alt="" />
              </span>
              <h3 className="mb-2 text-2xl font-bold text-white">
                Marissa Tang
              </h3>
              <p className="mx-auto max-w-xs text-lg">
                I do marketing, UI design, and community outreach alongside
                Chloe; I also handled the creation of our logo and social media
                profile pictures.
              </p>
            </li>
          </ul>
        </div>
        <div className="mb-16 border-b-2 border-gray-800">
          <h2 className="title mb-2 font-front sm:text-4xl md:text-5xl">
            Personalized, Perfected Experience
          </h2>
          <p className="intro mx-auto mb-20 sm:max-w-xl">
            Peace of Mind provides analytically accurate yet individually
            personalized services to everyone on and above the Earth without any
            charges. Here's what our app is about.
          </p>
          <div className="mb-8 flex flex-col sm:flex-row">
            <div className="mb-8 flex items-center sm:order-last sm:w-1/2 md:w-5/12">
              <img
                className="rounded-sm"
                src="img/features-split-image-01.png"
                alt=""
              />
            </div>
            <div className="mb-8 flex flex-col justify-center sm:w-1/2 sm:pr-16 md:w-7/12">
              <p className="mb-2 text-center text-sm font-semibold uppercase leading-none text-indigo-600 sm:text-left">
                Lightning fast workflow
              </p>
              <h3 className="title title-small sm:text-left md:text-4xl">
                Accurate Diagnosis Reports
              </h3>
              <p className="text md:text-left">
                Peace of Mind will not only determine the sentiment of the
                writing, but will also provide accurate, detailed reports on the
                type of mental health issue as well as the severity and
                suggested methods of alleviation. Peace of Mind accounts for 85%
                accuracy.
              </p>
            </div>
          </div>
          <div className="mb-8 flex flex-col sm:flex-row">
            <div className="mb-8 flex items-center sm:w-1/2 md:w-5/12">
              <img
                className="rounded-sm"
                src="img/features-split-image-02.png"
                alt=""
              />
            </div>
            <div className="mb-8 flex flex-col justify-center sm:w-1/2 sm:pl-16 md:w-7/12">
              <p className="mb-2 text-center text-sm font-semibold uppercase leading-none text-indigo-600 sm:text-left">
                Lightning fast workflow
              </p>
              <h3 className="title title-small sm:text-left md:text-4xl">
                A Space for Expression
              </h3>
              <p className="text md:text-left">
                Many of our users often feel a sense of relief to be provided
                with a safe and welcoming environment like Peace of Mind to
                express themselves, and ultimately improve the quality of their
                lives.
              </p>
            </div>
          </div>
          <div className="mb-8 flex flex-col sm:flex-row">
            <div className="mb-8 flex items-center sm:order-last sm:w-1/2 md:w-5/12">
              <img
                className="rounded-sm"
                src="img/features-split-image-03.png"
                alt=""
              />
            </div>
            <div className="mb-8 flex flex-col justify-center sm:w-1/2 sm:pr-16 md:w-7/12">
              <p className="mb-2 text-center text-sm font-semibold uppercase leading-none text-indigo-600 sm:text-left">
                Lightning fast workflow
              </p>
              <h3 className="title title-small sm:text-left md:text-4xl">
                Data-driven Sentiment Analysis
              </h3>
              <p className="text md:text-left">
                With thousands of data from various experts and sources, we
                perfect the quality of our sentiment analysis, which is based on
                the length of the journal, the word choices, and much more.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-16">
          <h2 className="title font-front sm:text-4xl md:text-5xl">
            User testimonials
          </h2>
          <p className="intro mx-auto sm:max-w-xl">
            Hear what our users, ranging from day-to-day people to astronauts,
            had to say about our app!
          </p>
          <div className="-ml-4 -mr-4 flex flex-col justify-center md:flex-row md:flex-wrap">
            <div className="mx-auto max-w-sm p-4 md:mx-0 md:w-1/2 md:max-w-full lg:w-1/3">
              <div className="bg-gray-800 p-8">
                <div className="mb-8 text-indigo-600">
                  <svg
                    className="fill-current"
                    width="24"
                    height="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 13.481c0-2.34.611-4.761 1.833-7.263C3.056 3.716 4.733 1.643 6.865 0L11 2.689C9.726 4.382 8.777 6.093 8.152 7.824c-.624 1.73-.936 3.578-.936 5.545V18H0v-4.519zm13 0c0-2.34.611-4.761 1.833-7.263 1.223-2.502 2.9-4.575 5.032-6.218L24 2.689c-1.274 1.693-2.223 3.404-2.848 5.135-.624 1.73-.936 3.578-.936 5.545V18H13v-4.519z"
                      fillRule="nonzero"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <blockquote className="mb-4 -mt-4 border-b border-gray-700 pb-8 text-lg">
                  — Duis aute irure dolor in reprehenderit in voluptate velit
                  esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum cillum dolore eu fugiat.
                </blockquote>
                <p className="font-semibold">
                  <span className="text-white">Roman Level</span>
                  <span className="text-gray-700">/</span>
                  <a href="/" className="text-green-400 hover:text-green-300">
                    Peace of Mind User
                  </a>
                </p>
              </div>
            </div>
            <div className="mx-auto max-w-sm p-4 md:mx-0 md:w-1/2 md:max-w-full lg:w-1/3">
              <div className="bg-gray-800 p-8">
                <div className="mb-8 text-indigo-600">
                  <svg
                    className="fill-current"
                    width="24"
                    height="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 13.481c0-2.34.611-4.761 1.833-7.263C3.056 3.716 4.733 1.643 6.865 0L11 2.689C9.726 4.382 8.777 6.093 8.152 7.824c-.624 1.73-.936 3.578-.936 5.545V18H0v-4.519zm13 0c0-2.34.611-4.761 1.833-7.263 1.223-2.502 2.9-4.575 5.032-6.218L24 2.689c-1.274 1.693-2.223 3.404-2.848 5.135-.624 1.73-.936 3.578-.936 5.545V18H13v-4.519z"
                      fillRule="nonzero"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <blockquote className="mb-4 -mt-4 border-b border-gray-700 pb-8 text-lg">
                  — Duis aute irure dolor in reprehenderit in voluptate velit
                  esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum cillum dolore eu fugiat.
                </blockquote>
                <p className="font-semibold">
                  <span className="text-white">Diana Rynzhuk</span>
                  <span className="text-gray-700">/</span>
                  <a href="/" className="text-green-400 hover:text-green-300">
                    Peace of Mind User
                  </a>
                </p>
              </div>
            </div>
            <div className="mx-auto max-w-sm p-4 md:mx-0 md:w-1/2 md:max-w-full lg:w-1/3">
              <div className="bg-gray-800 p-8">
                <div className="mb-8 text-indigo-600">
                  <svg
                    className="fill-current"
                    width="24"
                    height="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 13.481c0-2.34.611-4.761 1.833-7.263C3.056 3.716 4.733 1.643 6.865 0L11 2.689C9.726 4.382 8.777 6.093 8.152 7.824c-.624 1.73-.936 3.578-.936 5.545V18H0v-4.519zm13 0c0-2.34.611-4.761 1.833-7.263 1.223-2.502 2.9-4.575 5.032-6.218L24 2.689c-1.274 1.693-2.223 3.404-2.848 5.135-.624 1.73-.936 3.578-.936 5.545V18H13v-4.519z"
                      fillRule="nonzero"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <blockquote className="mb-4 -mt-4 border-b border-gray-700 pb-8 text-lg">
                  — Duis aute irure dolor in reprehenderit in voluptate velit
                  esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum cillum dolore eu fugiat.
                </blockquote>
                <p className="font-semibold">
                  <span className="text-white">Ben Stafford</span>
                  <span className="text-gray-700">/</span>
                  <a href="/" className="text-green-400 hover:text-green-300">
                    Peace of Mind User
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between border-t border-indigo-300">
          <div className="flex flex-row justify-center">
            <a
              href="https://www.instagram.com/peacemind8888/"
              className="p-4 text-indigo-300 hover:text-indigo-400"
            >
              <BsInstagram size={24} className="fill-current" />
            </a>
            <a
              href="https://www.linkedin.com/in/peacemind8888/"
              className="p-4 text-indigo-300 hover:text-indigo-400"
            >
              <BsLinkedin size={24} className="fill-current" />
            </a>
            <a
              href="https://www.youtube.com/@peacemind8888"
              className="p-4 text-indigo-300 hover:text-indigo-400"
            >
              <BsYoutube size={24} className="fill-current" />
            </a>
          </div>
          <div className="flex flex-col justify-between text-center sm:flex-row">
            <a href="/" className="px-4 hover:text-white">
              Contact
            </a>
            <a href="/" className="px-4 hover:text-white">
              About us
            </a>
            <a href="/" className="px-4 hover:text-white">
              FAQ's
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
